// Pushes a marketing event to the GTM dataLayer; GTM decides which tags (GA4, Google Ads,
// Meta, LinkedIn) fire for it.
//
// `done` runs once GTM has sent its tags, so a redirect right after doesn't cut them off.
// The fallback timeout covers GTM being blocked or not loaded (e.g. outside production).
export function track(event, params = {}, done) {
  window.dataLayer = window.dataLayer || [];
  const payload = { event, ...params };
  if (done) {
    let called = false;
    const finish = () => {
      if (!called) {
        called = true;
        done();
      }
    };
    payload.eventCallback = finish;
    payload.eventTimeout = 2000;
    setTimeout(finish, 2500);
  }
  window.dataLayer.push(payload);
}
